module.exports = __webpack_public_path__ + "media/images/illustrations/illustration-3-36e7bbe2b543c98cb15e7ff551bbad96.png";